import React, { Component } from 'react'
import { Route } from 'react-router-dom'
//import StudentReport from './reports/StudentReport'
import '../styles/GlobalStyle.css'
import StudentAssessments from './StudentAssessments'
import StudentCompletedAssessments from './StudentCompletedAssessments'
import StudentAssessment from './StudentAssessment'
import { firebase, db } from '../firebase/Firebase'
import { flattenDoc, getCurrentTimestamp, getCurrentYear, getIDFromURL, getQueryStringParam, getSchoolWeekNumber, getURLSplitArray, getYearStart, gradeText, injectBaseHref, isTestingTimeRangeExpired } from '../Util'
import ColType from '../Types'
import { Layout } from 'antd'
import StudentHeader from '../login/StudentHeader'
import StudentPractice from './StudentPractice'
import StudentPracticeResource from './StudentPracticeResource'
const moment = require('moment')

const StudentAssessmentsComponent = (props, state) => {
    return <StudentAssessments studentBaseProps={state} {...props} />
}

const StudentCompletedAssessmentsComponent = (props, state) => {
    return <StudentCompletedAssessments studentBaseProps={state} {...props} />
}

const StudentAssessmentComponent = (props, state) => {
    return <StudentAssessment studentBaseProps={state} {...props} />
}

const StudentPracticeComponent = (props, state) => {
    return <StudentPractice studentBaseProps={state} {...props} />
}

const StudentPracticeResourceComponent = (props, state) => {
    return <StudentPracticeResource studentBaseProps={state} {...props} />
}

class StudentBase extends Component {
    _unmounted = false;
    state = {
        studentId: '',
        student: null,
        prevGrade: '',
        assessments: [],
        assessmentsDict: {},
        completedAssessments: [],
        completedAssessmentsDict: {},
        retrieved: false,
        listeners: [],
        user: null,
        authListener: null,
        serverMoment: null,
        inTestingTimeRange: true,
        nextCheckTimeMilliseconds: 1,
        serverMomentTimeout: null,
        numAssessments: -1,
        district: null,
        demoToken: null,
        standardYears: null,
        activeYear: null,
        resources: [],
        quizzes: [],
        resourcesDict: {},
        quizzesDict: {},
        studentProgressDict: {},
        standardCategory: '',
        standardName: '',
        prevStandardCategory: 'init',
        prevStandardName: 'init',
        prevCurrentWeek: -1,
        currentWeek: 1,
        resourceCurrentWeek: 1,
        welcomeMessage: '',
        loadingResources: false,
        standardYears: null,
        activeYear: '',
        districtSettings: null,
        initialized: false,
        assessmentsInitialized: false,
        studentSettings: {
            enableReadAloudELA: false,
            enableReadAloudMath: false,
            enableReadAloudScience: false,
            enableReadAloudSocialStudies: false,
        },
        studentSettingsInitialized: false,
        setStandardCategoryFunc: (standardCategory) => { },
        setStandardNameFunc: (standardName) => { },
        onUpdateResourceOrQuizProgressFunc: (quizOrResourceId, progressObj) => { },
        onClearFunc: () => { },
        setResourceCurrentWeekFunc: (currentWeek) => { },
    }

    componentDidMount() {
        let split = getURLSplitArray(window.location)
        let studentId = split[split.length - 1]

        this.setState({
            studentId: studentId,
            setStandardCategoryFunc: this.setStandardCategory,
            setStandardNameFunc: this.setStandardName,
            onUpdateResourceOrQuizProgressFunc: this.onUpdateResourceOrQuizProgress,
            onClearFunc: this.onClear,
            setResourceCurrentWeekFunc: this.setResourceCurrentWeek,
        }, () => {
            let demoToken = getQueryStringParam('dt')
            let authListener = firebase.auth().onAuthStateChanged((user) => {
                if (user) {
                    //console.log('user', user)
                    this.setState({
                        user: user
                    }, () => {
                        this.getData(user)
                    })
                } else {
                    let redirectTo = '/sign-in/';
                    let mode = '';
                    if (this.state.user && this.state.user.dotitDemo) {
                        redirectTo = '/demo-sign-in/';
                    }
                    if (this.state.districtSettings.hasOwnProperty('isInactive') &&
                        this.state.districtSettings.isInactive) {
                        mode = '?mode=inactive';
                    }
                    window.location.href = redirectTo + mode
                }
            })

            this.setState({
                demoToken: demoToken,
                authListener: authListener
            })
        });
    }

    setResourceCurrentWeek = (resourceCurrentWeek) => {
        this.setState({
            resourceCurrentWeek: resourceCurrentWeek,
        }, () => {
            if (this.state.standardCategory && this.state.standardName) {
                this.getResources();
            }
        });
    }

    getWelcomeMessage = (user) => {
        if (!(user &&
            user.hasOwnProperty('firstName') &&
            user.firstName &&
            user.hasOwnProperty('lastName') &&
            user.lastName)) {
            return '';
        }
        let studentName = user.firstName;
        const randomIndex = Math.floor(Math.random() * 3);
        if (randomIndex === 0) {
            return `Welcome back, ${studentName}! Ready to learn something amazing today?`;
        } else if (randomIndex === 1) {
            return `Hi ${studentName}! Let's make today a great learning day.`;
        }

        return `Hello ${studentName}! What would you like to explore today?`;
    }

    getData = (user) => {
        if (this._unmounted) {
            return;
        }
        if (!this.state.studentId) {
            return;
        }
        // user must be defined before calling this function
        if (!user) {
            return
        }
        if (this.state.retrieved) {
            return
        }

        this.setState({ retrieved: true })

        if (!this.state.standardYears) {
            db.collection(ColType.standardYears)
                .doc('all')
                .get()
                .then((doc) => {
                    if (!doc.exists) {
                        //console.log('standardYears doc does not exist')
                        return
                    }
                    let standardYears = flattenDoc(doc)
                    let activeYear = standardYears.currentYear
                    this.setState({
                        standardYears: standardYears,
                        activeYear: standardYears.currentYear,
                    });
                });
        }

        db.collection(ColType.users).doc(this.state.studentId).get().then((doc) => {
            if (doc.exists) {
                let userValue = flattenDoc(doc)
                userValue.uid = user.uid
                //console.log('here', userValue)
                this.setState({
                    user: userValue,
                    welcomeMessage: this.getWelcomeMessage(userValue)
                })

                db.collection(ColType.district)
                    .doc(userValue.districtId)
                    .get()
                    .then((doc) => {
                        if (doc.exists) {
                            let district = flattenDoc(doc)
                            //console.log('district', district)
                            this.setState({
                                district: district
                            }, () => {
                                this.getServerTime()
                                if (this.state.student) {
                                    this.getPacingGuides(this.state.student.grade);
                                }
                            })
                        } else {
                            console.log('District not found')
                        }
                    });

                db.collection(ColType.districtSettings)
                    .doc(userValue.districtId)
                    .get()
                    .then((doc) => {
                        if (doc.exists) {
                            let districtSettings = flattenDoc(doc)
                            this.setState({
                                districtSettings: districtSettings,
                            }, () => {
                                if (districtSettings.hasOwnProperty('isInactive') &&
                                    districtSettings.isInactive) {
                                    firebase.auth().signOut().then(() => {

                                    }, function (error) {
                                        console.error('Sign Out Error', error)
                                    });
                                    return;
                                }

                                this.getServerTime()
                                if (this.state.student) {
                                    this.getPacingGuides(this.state.student.grade);
                                }
                            });
                        } else {
                            console.log('District settings not found')
                        }
                    });
            } else {
                console.log('user not found')
            }
        }).catch((error) => {
            console.log('Error getting document:', error)
        })

        db.collection(ColType.student)
            .doc(this.state.studentId)
            .get()
            .then((doc) => {
                if (doc.exists) {
                    let student = flattenDoc(doc)
                    this.setState({
                        student: student,
                    }, () => {
                        if (this.state.student) {
                            this.getPacingGuides(this.state.student.grade);
                        }
                    })
                }
            })
            .catch((error) => {
                console.log('Error getting student document:', error)
            });

        // console.log(user.uid, ColType.cleverStudentAssessments)

        const yearStart = getYearStart()
        let assessmentListener = db.collection(ColType.cleverStudentAssessments)
            .where('studentId', '==', this.state.studentId)
            .where('finalGrade.graded', '==', false)
            .where('status', '==', 'current')
            .where('timeStamp', '>=', yearStart)
            .orderBy('timeStamp', 'desc')
            .limit(50)
            .onSnapshot((querySnapshot) => {
                let assessments = []
                let assessmentsDict = {}

                querySnapshot.forEach((doc) => {
                    let assessment = flattenDoc(doc)
                    if (!(assessment.quiz.hasOwnProperty('version') &&
                        (assessment.quiz.version === '3.0' ||
                            assessment.quiz.version === '4.0')
                    )) {
                        assessment.quiz.docs = JSON.parse(assessment.quiz.docs)
                    }
                    assessments.push(assessment)
                    assessmentsDict[doc.id] = assessment
                })

                assessments.sort((a, b) => b.quiz.questionIdx - a.quiz.questionIdx)
                // sort by assessmentCategory, benchmark > common_assessment > quiz
                assessments.sort((a, b) => {
                    if (a.quiz.assessmentCategory === 'benchmark' && b.quiz.assessmentCategory !== 'benchmark') {
                        return -1
                    } else if (a.quiz.assessmentCategory !== 'benchmark' && b.quiz.assessmentCategory === 'benchmark') {
                        return 1
                    } else if (a.quiz.assessmentCategory === 'common_assessment' && b.quiz.assessmentCategory !== 'common_assessment') {
                        return -1
                    } else if (a.quiz.assessmentCategory !== 'common_assessment' && b.quiz.assessmentCategory === 'common_assessment') {
                        return 1
                    } else {
                        return 0
                    }
                })

                this.setState({
                    assessments: assessments,
                    assessmentsDict: assessmentsDict,
                    assessmentsInitialized: true,
                }, () => {
                    this.getNumOpenAssessments()
                })
            })

        // Modified completed assessment listener
        let completedAssessmentListener = db.collection(ColType.cleverStudentAssessments)
            .where('studentId', '==', this.state.studentId)
            .where('finalGrade.graded', '==', true)
            .where('status', '==', 'current')
            .where('timeStamp', '>=', yearStart)
            .orderBy('timeStamp', 'desc')
            .limit(50)
            .onSnapshot((querySnapshot) => {
                let completedAssessments = []
                let completedAssessmentsDict = {}

                querySnapshot.forEach((doc) => {
                    let completedAssessment = flattenDoc(doc)
                    if (!(completedAssessment.quiz.hasOwnProperty('version') &&
                        (completedAssessment.quiz.version === '3.0' ||
                            completedAssessment.quiz.version === '4.0')
                    )) {
                        completedAssessment.quiz.docs = JSON.parse(completedAssessment.quiz.docs)
                    }
                    completedAssessments.push(completedAssessment)
                    completedAssessmentsDict[doc.id] = completedAssessment
                })

                this.setState({
                    completedAssessments: completedAssessments,
                    completedAssessmentsDict: completedAssessmentsDict,
                })
            })

        let studentSettingsListener = db.collection(ColType.studentSettings)
            .doc(this.state.studentId)
            .onSnapshot((doc) => {
                let studentSettings = {
                    enableReadAloudELA: false,
                    enableReadAloudMath: false,
                    enableReadAloudScience: false,
                    enableReadAloudSocialStudies: false,
                }
                if (doc.exists) {
                    studentSettings = { ...studentSettings, ...flattenDoc(doc) }
                }
                this.setState({
                    studentSettings: studentSettings,
                    studentSettingsInitialized: true,
                })
            }, (error) => {
                console.log('Error listening to student settings:', error)
                this.setState({ studentSettingsInitialized: true })
            })


        this.setState({
            listeners: [assessmentListener, completedAssessmentListener, studentSettingsListener]
        })
    }

    getCurrentWeek = () => {
        return 1;
    }

    getPacingGuides = async (grade) => {
        if (!this.state.student || !this.state.district) {
            return;
        }
        if (this.state.prevGrade === grade) {
            return;
        }

        this.setState({
            prevGrade: grade,
        });

        let standardYears = this.state.standardYears
        let activeYear = this.state.activeYear
        if (!this.state.standardYears) {
            let doc = await db.collection(ColType.standardYears)
                .doc('all')
                .get()

            if (!doc.exists) {
                //console.log('standardYears doc does not exist')
                return
            }
            standardYears = flattenDoc(doc)
            activeYear = standardYears.currentYear
            this.setState({
                standardYears: standardYears,
                activeYear: standardYears.currentYear,
            })
        }

        const yearStart = getYearStart();
        const standardCategories = ['Math', 'ELA', 'Science', 'Social Studies'];
        let gradeStandardName = grade + gradeText(grade);
        let standardNamesDict = {
            Math: [gradeStandardName],
            ELA: [gradeStandardName],
            Science: [gradeStandardName],
            'Social Studies': [gradeStandardName]
        };

        if (this.state.district.state === 'NY' || this.state.district.state === 'SC') {
            if ('' + grade === '7') {
                standardNamesDict = {
                    Math: [gradeStandardName, '7th and 8th Grade Compacted'],
                    ELA: [gradeStandardName],
                    Science: [gradeStandardName],
                    'Social Studies': [gradeStandardName]
                };
            } else if ('' + grade === '8') {
                standardNamesDict = {
                    Math: [gradeStandardName, '7th and 8th Grade Compacted', '8th Grade and Geometry Compacted'],
                    ELA: [gradeStandardName],
                    Science: [gradeStandardName],
                    'Social Studies': [gradeStandardName]
                };
            } else if (['9', '10', '11', '12'].includes('' + grade)) {
                standardNamesDict = {
                    Math: ['8th Grade and Geometry Compacted', 'Algebra 1', 'Geometry with Statistics', 'Algebra 2 with Probability', 'Pre-Calculus', 'Calculus', 'Reasoning in Mathematics', 'Applications and Modeling', 'Statistical Modeling', 'Discrete Mathematics'],
                    ELA: ['English 1', 'English 2', 'English 3', 'English 4'],
                    Science: ['Biology', 'Chemistry', 'Physics', 'Earth and Space Science'],
                    'Social Studies': ['Human Geography', 'Modern World History', 'United States History and the Constitution', 'United States Government', 'Economics and Personal Finance']
                };
            }
        } else if (this.state.district.state === 'KY') {
            if (['9', '10', '11', '12'].includes('' + grade)) {
                standardNamesDict = {
                    Math: ['Number and Quantity', 'Algebra', 'Functions', 'Geometry', 'Statistics and Probability', 'Calculus'],
                    ELA: ['9th Grade', '10th Grade', '11th Grade', '12th Grade'],
                    Science: ['High School Life Sciences', 'High School Physical Sciences', 'High School Earth and Space Sciences'],
                    'Social Studies': ['Civics', 'Economics', 'Geography', 'United States History', 'World History']
                };
            }
        }

        let promises = [];
        let pacingGuidesDict = { Math: { asList: [], asDict: {} }, ELA: { asList: [], asDict: {} }, Science: { asList: [], asDict: {} }, 'Social Studies': { asList: [], asDict: {} } };
        standardCategories.forEach((standardCategory) => {
            standardNamesDict[standardCategory].forEach((standardName) => {
                let activeYear = this.state.activeYear
                //console.log('activeYear', activeYear, 'standardName', standardName, 'standardCategory', standardCategory);
                db.collection(ColType.pacingGuides)
                    .where('standardName', '==', standardName)
                    .where('standardCategory', '==', standardCategory)
                    .where('districtId', '==', this.state.district.id)
                    .where('year', '==', activeYear)
                    .limit(1)
                    .get()
                    .then((querySnapshot) => {
                        if (querySnapshot.empty) {
                            // pacing guides are created ahead of time
                            console.error('pacing guide does not exist')
                            // set pacing guide to empty
                            this.setState({
                                initialized: true,
                                pacingGuide: null,
                            })
                            return
                        }
                        if (querySnapshot.docs.length > 1) {
                            console.error('more than one pacing guide exists')
                        }

                        let pacingGuide = flattenDoc(querySnapshot.docs[0])

                        // always set week[0] to standards as they may have changed
                        let weeks = pacingGuide.weeks
                        // weeks[0] = []
                        //for (let standard of standards) {
                        //    weeks[0].push(standard)
                        // }

                        /*
                         // only used to determine which select we should show in LessonPlanV2
                         let pacingGuideHasData = false
                         let scheduledStandardsDict = {}
                         // skip week 0 (side menu)
                         for (let i = 1; i < this.state.totalWeeks; i++) {
                             let scheduledStandards = weeks[i]
                             if (scheduledStandards.length > 0) {
                                 pacingGuideHasData = true
                             }
                             for (let standard of scheduledStandards) {
                                 let key = standard.standard
                                 // if the scheduled standard is not in the side menu standards,
                                 // continue (this is to handle Biology standards in Earth Science)
                                 // Biology standards won't be in the side menu standards for Earth Science
                                 if (!standardsDict.hasOwnProperty(key)) {
                                     continue
                                 }
                                 if (!scheduledStandardsDict.hasOwnProperty(key)) {
                                     scheduledStandardsDict[key] = 0
                                 }
                                 scheduledStandardsDict[key] += 1
                             }
                         }*/

                        //console.log(pacingGuide)
                        pacingGuidesDict[standardCategory].asList.push(pacingGuide)
                        pacingGuidesDict[standardCategory].asDict[pacingGuide.standardName] = pacingGuide
                    })
            });
        });

        Promise.all(promises).then(() => {
            //console.log('pacingGuidesDict', pacingGuidesDict)
            this.setState({
                pacingGuidesDict: pacingGuidesDict,
                initialized: true,
            })
        });
    }

    getNumOpenAssessments = () => {
        if (!(this.state.assessments && this.state.serverMoment)) {
            return
        }
        // get number of assessments that are not past the default close
        // time of 1 week
        let numAssessments = 0
        this.state.assessments.map((assessment) => {
            if (!isTestingTimeRangeExpired(assessment, this.state.serverMoment)) {
                numAssessments += 1
            }

            return false
        })
        this.setState({
            numAssessments: numAssessments
        })
    }

    componentWillUnmount() {
        this._unmounted = true;
        this.state.listeners.map((listener) => {
            if (listener) {
                listener()
            }

            return false
        })

        if (this.state.authListener) {
            this.state.authListener()
        }

        if (this.state.serverMomentTimeout) {
            clearTimeout(this.state.serverMomentTimeout);
        }
    }

    componentWillUpdate(nextProps, nextState) {
        return true
    }

    getServerTime = () => {
        if (this._unmounted) {
            return;
        }
        if (!(this.state.studentId && this.state.user && this.state.district && this.state.districtSettings)) {
            return
        }
        if (this.state.serverMomentTimeout) {
            clearTimeout(this.state.serverMomentTimeout)
        }

        //console.log('getServerTime', this.state.nextCheckTimeMilliseconds)

        // timezone adjusted using district.state
        // calls setTimeout with the milliseconds to the next time to check.
        // if 8-3:30, then check at 3:30, if after 3:30, then check at 8:00 the next day
        // if after 3:30 on friday to sunday at 11:59 pm, then check at 8:00 on monday
        // if the user signs in again, then the timeout is cleared and reset and it
        // starts over again.
        let serverMomentTimeout = setTimeout(() => {
            getCurrentTimestamp(this.state.studentId, this.state.district.state)
                .then((pServerMoment) => {
                    const serverMoment = pServerMoment.clone()
                    const nextCheckObj = this.checkTimeAndCalculateNextCheck(serverMoment)
                    const inTestingTimeRange = nextCheckObj.inTestingTimeRange
                    const nextCheckTimeMilliseconds = nextCheckObj.nextCheckTimeMilliseconds

                    let yearStart = '2025-08-04';
                    if (this.state.districtSettings &&
                        this.state.districtSettings.hasOwnProperty('yearStart')) {
                        yearStart = this.state.districtSettings.yearStart;
                    }

                    //console.log(nextCheckTimeMilliseconds, inTestingTimeRange)
                    this.setState({
                        serverMoment: serverMoment,
                        currentWeek: getSchoolWeekNumber(serverMoment, yearStart),
                        resourceCurrentWeek: getSchoolWeekNumber(serverMoment, yearStart),
                        inTestingTimeRange: true,//inTestingTimeRange,
                        nextCheckTimeMilliseconds: nextCheckTimeMilliseconds
                    }, () => {
                        this.getNumOpenAssessments()
                        this.getServerTime()
                    })
                })
                .catch((error) => {
                    console.log('error', error)
                })
        }, this.state.nextCheckTimeMilliseconds)

        this.setState({
            serverMomentTimeout: serverMomentTimeout
        })
    }

    checkTimeAndCalculateNextCheck = (serverTime) => {
        if (!serverTime) {
            console.log('checkTimeAndCalculateNextCheck: serverMoment not set');
            return {
                inTestingTimeRange: true,
                nextCheckTimeMilliseconds: 10000
            };
        }

        // Get the day of the week: Sunday = 0, Monday = 1, ..., Saturday = 6
        const dayOfWeek = serverTime.day();

        // Create target time objects for 7:30 AM and 5:10 PM
        const startTime = serverTime.clone().hour(7).minute(28).second(0);
        const endTime = serverTime.clone().hour(17).minute(10).second(0);

        let nextCheckTime;
        let inTestingTimeRange = false;

        if (dayOfWeek === 0 || dayOfWeek === 6) {
            // It's a weekend - set to next Monday at 8:00 AM
            if (dayOfWeek === 0) {
                // Sunday -> Monday is 1 day
                nextCheckTime = serverTime.clone().add(1, 'days').hour(8).minute(0).second(0);
            } else {
                // Saturday -> Monday is 2 days
                nextCheckTime = serverTime.clone().add(2, 'days').hour(8).minute(0).second(0);
            }
        } else if (dayOfWeek === 5 && serverTime.isAfter(endTime)) {
            // It's Friday after 5:10 PM - set to next Monday at 8:00 AM (3 days later)
            nextCheckTime = serverTime.clone().add(3, 'days').hour(8).minute(0).second(0);
        } else if (serverTime.isBefore(startTime)) {
            // Before 7:28 AM on a weekday, so next check is at 7:28 AM today
            nextCheckTime = startTime;
        } else if (serverTime.isAfter(endTime)) {
            // After 5:10 PM on a weekday (Mon-Thu), so next check is at 7:28 AM tomorrow
            nextCheckTime = serverTime.clone().add(1, 'day').hour(7).minute(28).second(0);
        } else {
            // Between 7:28 AM and 5:10 PM on a weekday, so next check is at 5:10 PM today
            nextCheckTime = endTime;
            inTestingTimeRange = true;
        }

        // Calculate the difference in milliseconds
        let nextCheckTimeMilliseconds = nextCheckTime.diff(serverTime);

        // Safety check: ensure we never have a negative or very small timeout
        if (nextCheckTimeMilliseconds < 10000) {
            //console.warn('Calculated negative or very small timeout:', nextCheckTimeMilliseconds);
            //console.warn('Server time:', serverTime.format('YYYY-MM-DD HH:mm:ss'));
            //console.warn('Next check time:', nextCheckTime.format('YYYY-MM-DD HH:mm:ss'));
            nextCheckTimeMilliseconds = 10000; // Default to 10 seconds
        }

        //console.log('Next check scheduled for:', nextCheckTime.format('YYYY-MM-DD HH:mm:ss'));
        //console.log('Milliseconds until next check:', nextCheckTimeMilliseconds);

        return {
            inTestingTimeRange: inTestingTimeRange,
            nextCheckTimeMilliseconds: nextCheckTimeMilliseconds
        };
    };

    setStandardCategory = (standardCategory) => {
        let standardName = '';
        if (this.state &&
            this.state.pacingGuidesDict &&
            this.state.pacingGuidesDict.hasOwnProperty(standardCategory) &&
            this.state.pacingGuidesDict[standardCategory].asList.length === 1) {
            standardName = this.state.pacingGuidesDict[standardCategory].asList[0].standardName;
        }

        if (standardCategory && standardName) {
            this.setState({
                standardCategory: standardCategory,
                standardName: standardName,
            }, () => {
                this.getResources();
            });
        } else if (standardCategory) {
            this.setState({
                standardCategory: standardCategory,
                standardName: '',
            })
        }
    }

    setStandardName = (standardName) => {
        this.setState({
            standardName: standardName,
        }, () => {
            if (this.state.standardCategory) {
                this.getResources();
            }
        });
    }

    getResourceProgressDocId = (quizId) => {
        if (!quizId) {
            return '';
        }
        if (!this.state.student) {
            return '';
        }
        return this.state.student.id + '-' + quizId;
    }

    async getResources() {
        // Early validation checks
        if (!this.validateStateRequirements()) {
            this.resetResourceState();
            return;
        }

        let currentWeek = this.state.currentWeek;
        if (this.state.resourceCurrentWeek !== this.state.currentWeek) {
            currentWeek = this.state.resourceCurrentWeek;
        }

        // Check if we need to fetch new data
        if (this.state.prevStandardCategory === this.state.standardCategory &&
            this.state.prevStandardName === this.state.standardName &&
            this.state.prevCurrentWeek === currentWeek) {
            return;
        }

        // Update previous state
        this.setState({
            prevStandardCategory: this.state.standardCategory,
            prevStandardName: this.state.standardName,
            prevCurrentWeek: currentWeek,
            loadingResources: true,
        });

        // Get state (with NY -> SC mapping)
        const state = this.state.district.state === 'NY' ? 'SC' : this.state.district.state;

        // Get standards for current week
        const standards = this.getStandardsForCurrentWeek();
        if (!standards || standards.length === 0) {
            this.resetResourceState();
            return;
        }

        try {
            // Fetch all resources and quizzes in parallel
            const results = await Promise.all(
                standards.map(standard => this.fetchStandardData(standard, state))
            );

            // Aggregate results
            const aggregated = this.aggregateResults(results);

            // Update state with all data
            this.setState({
                resources: aggregated.resources,
                quizzes: aggregated.quizzes,
                resourcesDict: aggregated.resourcesDict,
                quizzesDict: aggregated.quizzesDict,
                studentProgressDict: aggregated.studentProgressDict,
                loadingResources: false,
            });

        } catch (error) {
            console.error('Error getting resources:', error);
            this.resetResourceState();
        }
    }

    // Helper methods

    validateStateRequirements() {
        return !!(
            this.state &&
            this.state.district &&
            this.state.pacingGuidesDict &&
            this.state.pacingGuidesDict[this.state.standardCategory] &&
            this.state.pacingGuidesDict[this.state.standardCategory].asDict[this.state.standardName] &&
            this.state.standardCategory &&
            this.state.standardName
        );
    }

    resetResourceState() {
        this.setState({
            resources: [],
            quizzes: [],
            resourcesDict: {},
            quizzesDict: {},
            studentProgressDict: {},
            loadingResources: false,
        });
    }

    getStandardsForCurrentWeek() {
        let currentWeek = this.state.currentWeek;
        if (this.state.resourceCurrentWeek !== this.state.currentWeek) {
            currentWeek = this.state.resourceCurrentWeek;
        }
        const pacingGuide = this.state.pacingGuidesDict[this.state.standardCategory].asDict[this.state.standardName];
        return pacingGuide.weeks[currentWeek] || [];
    }

    async fetchStandardData(standard, state) {
        const resourceData = await this.fetchResourceForStandard(standard, state);
        return {
            resource: resourceData.resource,
            resourceProgress: resourceData.progress,
            quizzes: [],
            quizProgress: {}
        };
        /*const [resourceData, quizData] = await Promise.all([
            this.fetchResourceForStandard(standard, state),
            this.fetchQuizzesForStandard(standard, state)
        ]);

        return {
            resource: resourceData.resource,
            resourceProgress: resourceData.progress,
            quizzes: quizData.quizzes,
            quizProgress: quizData.progress
        };*/
    }

    async fetchResourceForStandard(standard, state) {
        try {
            const querySnapshot = await db.collection(ColType.studentResources)
                .where('state', '==', state)
                .where('standard.standardName', '==', this.state.standardName)
                .where('standard.standardCategory', '==', this.state.standardCategory)
                .where('standard.standard', '==', standard.standard)
                .where('version', '==', '3.0')
                .orderBy('createdAt', 'desc')
                .limit(1)
                .get();

            if (querySnapshot.empty) {
                return { resource: null, progress: null };
            }

            const doc = querySnapshot.docs[0];
            const studentResource = flattenDoc(doc);
            studentResource.doc = injectBaseHref(studentResource.doc);

            // Fetch progress for this resource
            const progress = await this.fetchResourceProgress(studentResource.id);

            return { resource: studentResource, progress };

        } catch (error) {
            console.error('Error fetching resource for standard:', standard.standard, error);
            return { resource: null, progress: null };
        }
    }

    async fetchQuizzesForStandard(standard, state) {
        try {
            const querySnapshot = await db.collection(ColType.quizzes)
                .where('standardName', '==', this.state.standardName)
                .where('standardCategory', '==', this.state.standardCategory)
                .where('standards', 'array-contains', standard.standard)
                .where('assessmentCategory', '==', 'quiz')
                .where('state', '==', state)
                .where('year', '==', '2024')
                .where('districtId', '==', '__all__')
                .where('live', '==', true)
                .orderBy("createdAt", "asc")
                .get();

            const quizzes = [];
            const progressPromises = [];

            querySnapshot.forEach((doc) => {
                const quiz = flattenDoc(doc);

                // Process quiz based on version
                if (quiz.version === '3.0' || quiz.version === '4.0') {
                    quizzes.push(quiz);
                } else {
                    // Legacy quiz processing
                    quiz.docs = JSON.parse(quiz.docs);
                    quiz.docs = quiz.docs.map(doc => {
                        try {
                            if (doc.components && doc.components[0] && doc.components[0].answers) {
                                doc.components[0].answers = shuffleArray(doc.components[0].answers);
                            }
                        } catch (e) {
                            // Skip shuffling if structure is unexpected
                        }
                        return doc;
                    });
                    quizzes.push(quiz);
                }

                // Add progress fetch promise
                progressPromises.push(this.fetchResourceProgress(quiz.id));
            });

            // Fetch all progress in parallel
            const progressResults = await Promise.all(progressPromises);

            // Map progress to quiz IDs
            const progress = {};
            quizzes.forEach((quiz, index) => {
                progress[quiz.id] = progressResults[index];
            });

            return { quizzes, progress };

        } catch (error) {
            console.error('Error fetching quizzes for standard:', standard.standard, error);
            return { quizzes: [], progress: {} };
        }
    }

    async fetchResourceProgress(resourceId) {
        const docId = this.getResourceProgressDocId(resourceId);
        if (!docId) {
            return null;
        }

        try {
            const doc = await db.collection(ColType.studentResourceProgress)
                .doc(docId)
                .get();

            if (doc.exists) {
                const progress = flattenDoc(doc);
                return progress;
            }
            return null;

        } catch (error) {
            console.error('Error fetching progress for resource:', resourceId, error);
            return null;
        }
    }

    aggregateResults(results) {
        const resources = [];
        const quizzes = [];
        const resourcesDict = {};
        const quizzesDict = {};
        const studentProgressDict = {};

        results.forEach(result => {
            // Add resource if it exists
            if (result.resource) {
                resources.push(result.resource);
                resourcesDict[result.resource.id] = result.resource;
                studentProgressDict[result.resource.id] = result.resourceProgress || null;
            }

            // Add quizzes
            result.quizzes.forEach(quiz => {
                quizzes.push(quiz);
                quizzesDict[quiz.id] = quiz;
                studentProgressDict[quiz.id] = result.quizProgress[quiz.id] || null;
            });
        });

        //console.log(studentProgressDict);
        return {
            resources,
            quizzes,
            resourcesDict,
            quizzesDict,
            studentProgressDict
        };
    }

    onUpdateResourceOrQuizProgress = (quizOrResourceId, progressObj) => {
        if (!quizOrResourceId || !progressObj) {
            return;
        }

        // Update the state with the new progress
        this.setState((prevState) => {
            const updatedStudentProgressDict = { ...prevState.studentProgressDict };
            updatedStudentProgressDict[quizOrResourceId] = {
                ...updatedStudentProgressDict[quizOrResourceId],
                ...progressObj
            };

            return {
                studentProgressDict: updatedStudentProgressDict
            };
        });
    }

    onClear = () => {
        this.setState({
            standardCategory: '',
            standardName: '',
            prevStandardCategory: 'init',
            prevStandardName: 'init',
            resources: [],
            quizzes: [],
            resourcesDict: {},
            quizzesDict: {},
            studentProgressDict: {},
            resourceCurrentWeek: this.state.currentWeek,
            prevCurrentWeek: -1,
            loadingResources: false,
        });
    }

    render() {
        const { match: { url } } = this.props
        //console.log(this.props, this.state)

        return (
            <Layout>
                <StudentHeader
                    studentBaseProps={this.state}
                    studentId={this.state.studentId}
                    user={this.state.user}
                    person={this.state.user ?
                        {
                            firstName: this.state.user.firstName ? this.state.user.firstName : '',
                            lastName: this.state.user.lastName ? this.state.user.lastName : '',
                        } : null}
                    district={this.state.district}
                />

                <Route path={`${url}/quizzes`} render={props => StudentAssessmentsComponent(props, this.state)} />
                <Route path={`${url}/completed-quizzes`} render={props => StudentCompletedAssessmentsComponent(props, this.state)} />
                <Route path={`${url}/quiz`} render={props => StudentAssessmentComponent(props, this.state)} />
                <Route path={`${url}/practice`} render={props => StudentPracticeComponent(props, this.state)} />
                <Route path={`${url}/practice-resource`} render={props => StudentPracticeResourceComponent(props, this.state)} />
            </Layout>
        )
    }
}

export default StudentBase